import type { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import './auth.css';

/**
 * The frame every signed-out screen sits in: the workshop photograph and an
 * ivory sheet. On a phone the photograph is a short band and the sheet rises
 * over it; from 960px the photograph takes the left of the screen.
 *
 * Purely presentational — no auth logic lives here.
 */
export function AuthShell({ children }: { children: ReactNode }) {
    return (
        <div data-theme="dark" className="fda">
            <header className="fda-scene">
                <div className="fda-scene__photo" aria-hidden="true" />
                <a href="https://forgedash.uk" className="fda-brand" aria-label="ForgeDash — back to forgedash.uk">
                    <img src="/logo.webp" alt="" width={24} height={27} />
                    <span>ForgeDash</span>
                </a>
                <p className="fda-scene__line">
                    Run the job. <span>The paperwork keeps up.</span>
                </p>
                <ul className="fda-scene__facts">
                    <li>For sole-trader mechanics in the UK</li>
                    <li>Free plan: up to 10 jobs a month</li>
                    <li>No card required</li>
                </ul>
            </header>

            <main className="fda-sheet">
                <div className="fda-sheet__inner">
                    {children}
                    <a href="https://forgedash.uk" className="fda-back">
                        <ArrowLeft className="w-4 h-4" aria-hidden="true" /> Back to forgedash.uk
                    </a>
                </div>
            </main>
        </div>
    );
}
